import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { user } from "../../store/auth/actions";
export var useUserGetAll = function (trigger, page, limit, query, deleted, hasRole) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a, _b;
        return ({
            responseUser: (_a = state.Login.responseUser) === null || _a === void 0 ? void 0 : _a.data,
            pagingInfo: (_b = state.Login.responseUser) === null || _b === void 0 ? void 0 : _b.pagingInfo,
            errorUser: state.Login.errorUser,
            loadingUser: state.Login.loadingUser,
        });
    }), responseUser = _a.responseUser, errorUser = _a.errorUser, loadingUser = _a.loadingUser, pagingInfo = _a.pagingInfo;
    useEffect(function () {
        if (trigger) {
            dispatch(user({
                page: page,
                limit: limit,
                enabled: true,
                query: query || "",
                deleted: deleted,
                hasRole: hasRole,
            }));
        }
    }, [trigger, query, deleted, hasRole]);
    return {
        responseUser: responseUser,
        pagingInfo: pagingInfo,
        errorUser: errorUser,
        loadingUser: loadingUser,
    };
};
